import { DropdownMenuProps } from "@radix-ui/react-dropdown-menu";

import { DropdownMenu, DropdownMenuTrigger } from "@/components/atoms/ui/dropdown-menu";
import { Button } from "@/components/atoms/prime/Button";
import { IGIREMenuItem } from "@/router/models/router.types";

import { DropdownMenuContent } from "./DropdownMenuContent";
import { DropdownMenuItem } from "./DropdownMenuItem";
import { ItemLevel1 } from "./ItemLevel1Template";

type Props = DropdownMenuProps & {
  item: IGIREMenuItem;
};

export function EndMenu({ item, ...props }: Props) {
  if (!item?.items || item.items.length === 0) return null;

  return (
    <DropdownMenu {...props}>
      <DropdownMenuTrigger asChild>
        <Button
          link
          aria-label={item.label}
          className="cursor-pointer outline-0"
          icon={item.icon}
          size="small"
          tooltip={item.label}
          tooltipOptions={{ position: "left" }}
        />
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end">
        {item.items.map((subItem) => (
          <DropdownMenuItem key={String(subItem.url ?? subItem.label)} asChild>
            <ItemLevel1 item={subItem} />
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
